import { keyframes } from "@mui/system";
import { colors } from "../../styles";

const rotateAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export default {
    loadingContainer: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        background: colors.lightGrey,
        zIndex: 9999,
        height: "100%",
        opacity: 0.5
    },
    container: {
        display: "flex",
        height: "100%",
        flexFlow: "column",
        alignItems: "center",
        justifyContent: "center"
    },
    textContainer: {
        mx: 1
    },
    spinner: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100vw"
    },
    loaderRoller: {
        position: "relative",
        display: "inline-block",
        height: "64px",
        width: "64px",
        "& div": {
            animation: `${rotateAnimation} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite`,
            transformOrigin: "32px 32px",
            "&:after": {
                position: "absolute",
                display: "block",
                backgroundColor: colors.blue,
                borderRadius: "50%",
                content: '" "',
                margin: "-3px 0 0 -3px",
                height: "6px",
                width: "6px"
            }
        },
        /** Nth child anivmation based on the multiples  */
        "& div:nth-of-type(1)": {
            animationDelay: "-0.036s",
            "&:after": { top: "50px", left: "50px" }
        },
        "& div:nth-of-type(2)": {
            animationDelay: "-0.072s",
            "&:after": { top: "54px", left: "45px" }
        },
        "& div:nth-of-type(3)": {
            animationDelay: "-0.108s",
            "&:after": { top: "57px", left: "39px" }
        },
        "& div:nth-of-type(4)": {
            animationDelay: "-0.144s",
            "&:after": { top: "58px", left: "32px" }
        },
        "& div:nth-of-type(5)": {
            animationDelay: "-0.18s",
            "&:after": { top: "57px", left: "25px" }
        },
        "& div:nth-of-type(6)": {
            animationDelay: "-0.216s",
            "&:after": { top: "54px", left: "19px" }
        },
        "& div:nth-of-type(7)": {
            animationDelay: "-0.252s",
            "&:after": { top: "50px", left: "14px" }
        },
        "& div:nth-of-type(8)": {
            animationDelay: "-0.288s",
            "&:after": { top: "45px", left: "10px" }
        }
    },
    "@keyframes lds-roller": {
        "0%": {
            transform: "rotate(0deg)"
        },
        "100%": {
            transform: "rotate(360deg)"
        }
    }
};
